import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"

import AppUsers from "components/UserManagement/AppUsers/AppUsers"

const LinkAppUsers = props => {
  const [usedIn] = useState({
    LinkAppUsers,
  })

  useEffect(() => {
    document.title = props.t("Customer management") + " | Suvanto Care"
  }, [])

  return (
    <>
      <AppUsers
        suvantoKey={props.suvantoKey}
        group={props.group}
        usedIn={usedIn}
      />
    </>
  )
}

LinkAppUsers.propTypes = {
  t: PropTypes.any,
  suvantoKey: PropTypes.string,
  group: PropTypes.string,
}

export default withTranslation()(LinkAppUsers)
